import React from "react";
import BtnOLevelResult from "../../buttons/BtnOLevelResult";
import { useQuery } from "@tanstack/react-query";
import { axiosget } from "../../helpers/httprequest";
import BtnOLevelResultDel from "../../buttons/BtnOLevelResultDel";
import moment from "../../helpers/moment";
import ErrorResponse from "../../components/ErrorResponse";
import Loader from "../../components/Loader";

const OLevelResult = () => {
  const { isLoading, error, data } = useQuery({
    queryKey: ["oLevelResult"],
    queryFn: async () => {
      const req = await axiosget("ms_applicant_result");
      return req?.data;
    },
  });
  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className="row ">
          {error && <ErrorResponse type={"danger"} message={"Sorry, system could not find data"} />}
          {!error && data && (
            <>
              {data?.map((v, i) => (
                <div className="col-md-4 my-2" key={`_olevel_sitting_${i}`}>
                  <div className="card text-center border border-success">
                    <div className="card-header">{v?.examination?.examinationnumber}</div>
                    <div className="card-body">
                      <h5 className="card-title">{v?.examination?.examinationtype}</h5>
                      <p className="card-text">{v?.subject}</p>
                      <p className="card-text">{v?.scored}</p>
                      <div className="d-flex justify-content-center ">
                        <BtnOLevelResult modules={v} key={`oLevel_${i}`} />
                        <div className="p-1"></div>
                        <BtnOLevelResultDel modules={v} key={`oLevel_del_${i}`} />
                      </div>
                    </div>
                    <div className="card-footer text-body-secondary">{moment(v.createdAt)} ago</div>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
      )}
      <BtnOLevelResult />
    </>
  );
};

export default OLevelResult;
